import groq from "groq";
import metaFields from "./metaFields";
import { applyFrench } from "@lib/applyFrenchField";

const shippingInfo = `${applyFrench(
  `shippingInfo[] {
      ...,
      markDefs[]{
        ...,
        _type == "internalLink" => {
          "type": @->_type,
          "slug": @->slug,
          "handle": @->handle,
        },
      },
    }`,
  `shippingInfo_fr.portableText[] {
      ...,
      markDefs[]{
        ...,
        _type == "internalLink" => {
          "type": @->_type,
          "slug": @->slug,
          "handle": @->handle,
        },
      },
    }`
)}`;

const productSettings = groq`
  *[_id == 'products-global-settings'] | order(_updatedAt desc) {
    ${metaFields}
    "shippingInfo": ${shippingInfo}
  }[0]
`;

export default productSettings;
